<template>
  <tr>
    <td>
      <UserLinkByText :value="item" />
    </td>
    <td class="right">{{rcpCount}}</td>
    <td class="right">{{healthUseMind.requestCount}}</td>
    <td class="right">{{healthUseMind.requestUserCount}}</td>
    <td class="right">{{healthUseGood.requestCount}}</td>
    <td class="right">{{healthUseGood.requestUserCount}}</td>
  </tr>
</template>

<script>
import statsMixin from "$views/Stats/v2/_mixin";
export default {
  mixins: [statsMixin],
  props: {
    item: String,
    rcpCount: Number,
    healthUseMind: Object,
    healthUseGood: Object
  }
};
</script>